module.exports = __webpack_public_path__ + "static/media/3.53fedbf6.mp3";